import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {
  @Input() pageNo = 1;
  @Input() pageSize = 10;
  @Input() totalCount = 0;
  @Input() pageSizeOptions: number[] = [10, 25, 50, 100];

  @Output() pageNoChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  totalPages = 0;
  visiblePages: number[] = [];

  private static readonly WINDOW_SIZE = 5;

  ngOnChanges(): void {
    this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
    this.recomputeWindow();
  }

  get rangeStart(): number {
    return this.totalCount === 0 ? 0 : (this.pageNo - 1) * this.pageSize + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.pageNo * this.pageSize, this.totalCount);
  }

  goTo(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.pageNo) return;
    this.pageNoChange.emit(page);
  }

  onPageSizeSelect(value: string): void {
    this.pageSizeChange.emit(Number(value));
  }

  private recomputeWindow(): void {
    const windowSize = PaginationComponent.WINDOW_SIZE;
    const half = Math.floor(windowSize / 2);
    let start = Math.max(1, this.pageNo - half);
    const end = Math.min(this.totalPages, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);

    this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }
}
